import React from 'react'

export default function RedirectIcon({ color = '#C4C4C4', width = '20', heigth = '20' }) {
  return (
    <svg width={width} height={heigth} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 1H11C10.4478 1 10 1.44781 10 2C10 2.55219 10.4478 3 11 3H13C13.5522 3 14 3.44781 14 4V12C14 12.5522 13.5522 13 13 13H11C10.4478 13 10 13.4478 10 14C10 14.5522 10.4478 15 11 15H13C14.6569 15 16 13.6569 16 12V4C16 2.34312 14.6562 1 13 1ZM10.7063 7.29375L6.70625 3.29375C6.31531 2.90281 5.6825 2.90344 5.29219 3.29375C4.90156 3.68438 4.90156 4.31719 5.29219 4.70781L7.5875 7H1C0.447187 7 0 7.44688 0 8C0 8.55312 0.447187 9 1 9H7.5875L5.29437 11.2931C4.90375 11.6838 4.90375 12.3166 5.29437 12.7072C5.685 13.0978 6.31781 13.0978 6.70844 12.7072L10.7084 8.70719C11.0969 8.31563 11.0969 7.68437 10.7063 7.29375Z" fill={color} />
    </svg>
  )
}

